import {useAppSelector} from "./store";
import {ProfileState} from "../store/profile";

export const useProfileData = () => {
  return useAppSelector<ProfileState>((state) => state.profile);
};